import { Component, ViewChild, TemplateRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AuService } from '../au.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-au-recommendations',
  templateUrl: './au-recommendations.component.html',
  styleUrls: ['./au-recommendations.component.scss']
})

export class AuRecommendationsComponent implements OnDestroy, OnInit {

  infoIconSrc: string = 'src/assets/img/info-yellow.png';

  isProcessing = true;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  makeStickyColumns: any;
  auRecommendationsDataForGrid: any = [];
  auRecommendationsDataForGridTemp: any = [];
  columnLists: any = {};
  dataTypeList: any = [];
  searchText: any;
  searchValue: any;
  showingRowsText = "Showing rows";
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  dateCustomClasses: DatepickerDateCustomClasses[];
  editorValue: string = '';
  editorMode: string = 'edit';
  textareaEditorTitle: string = '';
  isFrozen: boolean = false;
  config: EditorConfig = {
    buttons: []
  };
  config1: EditorConfig = {
    buttons: ST_BUTTONS
  };
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };
  allowEditing: boolean = false;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    private readonly elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService, public auService: AuService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.isFrozen = this.auService.isAuditee;
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };
  showRecommandAddBtn: boolean = false;
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);
  ngOnInit() {

    this.getcallMethod();
    if (this.qmsservice.moduleName == 'AU' && (this.qmsservice.activity.status == 'Received Q&A Response' || this.qmsservice.activity.status == 'In Progress/Received Q&A Response'
      || this.qmsservice.activity.status == 'In Progress' || this.qmsservice.activity.status == 'Peer Review Rejected'
      || this.qmsservice.activity.status == 'Peer Reviewer Requested More Info.' || this.qmsservice.activity.status == 'Findings In Progress'
      || this.qmsservice.activity.status == 'Closed/Finding In Progress'
      || this.qmsservice.activity.status == 'Auditee Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Approver Requested More Info.' || this.qmsservice.activity.status == 'Closure Reviewer Requested More Info.'
      || this.qmsservice.activity.status == 'Closure Review Rejected' || this.qmsservice.activity.status == 'Closure Approval Rejected') && this.auService.isAuditor) {
      this.showRecommandAddBtn = true;
    } else {
      this.showRecommandAddBtn = false;
    }
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
  }



  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  getcallMethod() {
    this.isProcessing = true;
    const data = {

      gridName: "AU_RECOMMENDATIONS",
      groupId: 0
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_AU_RECOMMENDATIONS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          auNoFromAu: this.message.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.auRecommendationsDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const element of this.auRecommendationsDataForGrid) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType === 'CHECKBOX') {
                      element[dataType.columnName] = element[dataType.columnName] === "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.labelcall();
                this.setPage(1, 0);
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.auRecommendationsDataForGrid;
            this.collectionSize = this.auRecommendationsDataForGrid.length;
            this.totalPages = Math.ceil(this.auRecommendationsDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    this.isProcessing = true;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          this.dynamicLabel = acc;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        return this.dynamicLabel
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  htmlContent: any;
  @ViewChild('editor') editor!: TemplateRef<any>;
  visibleangularEditorTextareaPopup!: MatDialogRef<any>;

  fieldNameMap: { [key: string]: string } = {
    "Description": "description",
    "Reference Details": "referenceDetails",
    "Auditee Comments": "auditeeComments"
  };

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData1(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error) => {
        throw error;
      }
    });
    this.isProcessing = false;
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.auRecommendationsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.auRecommendationsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.auRecommendationsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.auRecommendationsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.auRecommendationsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.auRecommendationsDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.auRecommendationsDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.auRecommendationsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.auRecommendationsDataForGridTemp = this.auRecommendationsDataForGrid;
      this.pager = this.paginationService.getPager(this.auRecommendationsDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.auRecommendationsDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.auRecommendationsDataForGrid == undefined) {
        return this.auRecommendationsDataForGrid;
      }
      if (!this.auRecommendationsDataForGrid.length) {
        return this.auRecommendationsDataForGrid;
      }
      if (filter) {
        this.auRecommendationsDataForGridTemp = this.auRecommendationsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.auRecommendationsDataForGridTemp = this.auRecommendationsDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.auRecommendationsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.auRecommendationsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.auRecommendationsDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.RECOMMENDATION_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.auRecommendationsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  qmsAuRecommendationsFieldData: any = {};
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '15px' },
    maxHeight: '75vw'
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  popupTitle: any;
  visibleEditButton: boolean;
  visibleAddButton: boolean;
  operationFlag: any;
  openAddPopup() {
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Audit Recommendation";
    this.visibleEditButton = true;
    [this.qmsAuRecommendationsFieldData.description, this.qmsAuRecommendationsFieldData.referenceDetails, this.qmsAuRecommendationsFieldData.auditeeComments] = ['', '', '']
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingRecommendationId: any;
  objForDocuments: any;
  openEditPopup(qmsAuRecommendationsFieldData: any, mode: any, index: any) {
    if (mode == 'VIEW') {
      this.operationFlag = 'VIEW';
    } else {
      this.operationFlag = 'EDIT';
    }

    if (this.operationFlag == 'EDIT' || (this.operationFlag == 'VIEW' && index == 0)) {
      this.isProcessing = true;
      this.popupTitle = this.operationFlag == 'EDIT' ? "Update Audit Recommendation" : 'Audit Recommendation';
      this.visibleEditButton = false;
      this.editingRecommendationId = qmsAuRecommendationsFieldData.RECOMMENDATION_ID;
      this.auService.recommendationId = qmsAuRecommendationsFieldData.RECOMMENDATION_ID;
      this.objForDocuments = {
        id: qmsAuRecommendationsFieldData.RECOMMENDATION_ID,
        pagename: "Audit Recommendation"
      };
      this.appService.getRecommendationByRecommendationId(this.editingRecommendationId).subscribe((data: any) => {
        this.qmsAuRecommendationsFieldData = data;
        this.qmsAuRecommendationsFieldData.auditeeComments ??= '';
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      })
    }
  }

  deletingRecommendationId: any;
  openDeletePopup(qmsAuRecommendationsFieldData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Audit Recommendation";
    this.deletingRecommendationId = qmsAuRecommendationsFieldData.RECOMMENDATION_ID;
    this.qmsAuRecommendationsFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  descriptionFieldValue: any;
  referenceDetailsFieldValue: any;
  fieldValidation() {
    this.descriptionFieldValue = document.getElementById('description-validation') as HTMLInputElement;
    this.referenceDetailsFieldValue = document.getElementById('referenceDetails-validation') as HTMLInputElement;

    if (this.qmsAuRecommendationsFieldData.description == '' || this.qmsAuRecommendationsFieldData.description == undefined) {
      this.descriptionFieldValue.style.color = 'red';
    } else {
      this.descriptionFieldValue.style.color = '#005c8a';
    }

    if (this.qmsAuRecommendationsFieldData.referenceDetails == '' || this.qmsAuRecommendationsFieldData.referenceDetails == undefined) {
      this.referenceDetailsFieldValue.style.color = 'red';
    } else {
      this.referenceDetailsFieldValue.style.color = '#005c8a';
    }
  }

  onFieldFocusout() {
    if (this.descriptionFieldValue != undefined) {
      if (this.qmsAuRecommendationsFieldData.description == "" || this.qmsAuRecommendationsFieldData.description == undefined) {
        this.descriptionFieldValue.style.color = 'red';
      } else {
        this.descriptionFieldValue.style.color = '#005c8a';
      }
    }

    if (this.referenceDetailsFieldValue != undefined) {
      if (this.qmsAuRecommendationsFieldData.referenceDetails == "" || this.qmsAuRecommendationsFieldData.referenceDetails == undefined) {
        this.referenceDetailsFieldValue.style.color = 'red';
      } else {
        this.referenceDetailsFieldValue.style.color = '#005c8a';
      }
    }

    if (this.deleteReasonfieldValidation != undefined) {
      if (this.qmsAuRecommendationsFieldData.deleteReason == "" || this.qmsAuRecommendationsFieldData.deleteReason == undefined) {
        this.deleteReasonfieldValidation.style.color = 'red';
      } else {
        this.deleteReasonfieldValidation.style.color = '#005c8a';
      }
    }
  }

  // Utility to check if HTML content is empty (ignores tags like <br>, <p></p>, etc.)
  isContentEmpty(content: string): boolean {
    if (content == null || content === undefined) return true;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }

  addAndEditFunction(qmsAuRecommendationsFieldData: any) {
    const descriptionLabel = document.getElementById('description-validation');
    const referenceLabel = document.getElementById('referenceDetails-validation');
    const isDescriptionEmpty = !qmsAuRecommendationsFieldData.description;
    const isReferenceEmpty = !qmsAuRecommendationsFieldData.referenceDetails;
    if (isDescriptionEmpty) {
      descriptionLabel?.classList.add('error-label');
    } else {
      descriptionLabel?.classList.remove('error-label');
    }

    if (isReferenceEmpty) {
      referenceLabel?.classList.add('error-label');
    } else {
      referenceLabel?.classList.remove('error-label');
    }

    // Show alert and return if validation fails
    if (isDescriptionEmpty || isReferenceEmpty) {
      alert('Please fill in all mandatory fields.');
      return;
    }
    this.isProcessing = true;
    // Set fields to null if empty
    if (!qmsAuRecommendationsFieldData.description || this.isContentEmpty(qmsAuRecommendationsFieldData.description)) {
      qmsAuRecommendationsFieldData.description = null;
    }
    if (!qmsAuRecommendationsFieldData.referenceDetails || this.isContentEmpty(qmsAuRecommendationsFieldData.referenceDetails)) {
      qmsAuRecommendationsFieldData.referenceDetails = null;
    }
    if (!qmsAuRecommendationsFieldData.auditeeComments || this.isContentEmpty(qmsAuRecommendationsFieldData.auditeeComments)) {
      qmsAuRecommendationsFieldData.auditeeComments = null;
    }

    if (qmsAuRecommendationsFieldData.description == "" || qmsAuRecommendationsFieldData.referenceDetails == "") {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      let data = {
        auNo: this.message.activityId,
        description: qmsAuRecommendationsFieldData.description,
        referenceDetails: qmsAuRecommendationsFieldData.referenceDetails,
        auditeeComments: qmsAuRecommendationsFieldData.auditeeComments,
        seq: qmsAuRecommendationsFieldData.seq
      }


      if (this.operationFlag == 'ADD') {
        this.appService.createQmsAuRecommendation(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete qmsAuRecommendationsFieldData.createdOn;
        delete qmsAuRecommendationsFieldData.updatedOn;

        const modifiedData = {
          ...data,
          recommendationId: this.editingRecommendationId
        }

        this.appService.updateQmsAuRecommendation(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReasonfieldValidation: any;
  deleteFunction(qmsAuRecommendationsFieldData: any) {
    if (this.qmsAuRecommendationsFieldData.deleteReason) {
      this.isProcessing = true;
      let data = {
        recommendationId: this.deletingRecommendationId,
        auNo: this.message.activityId,
        deleteReason: qmsAuRecommendationsFieldData.deleteReason
      }
      this.appService.deleteQmsAuRecommendation(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.ngOnInit();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.deleteReasonfieldValidation = document.getElementById('delete-reason-validation') as HTMLInputElement;
      this.deleteReasonfieldValidation.style.color = 'red';
      alert('Please enter the all mandatory fields...');
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, recommendation: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : recommendation.RECOMMENDATION_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'AU_RECOMMENDATIONS';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Recommendation Audit Trail [' + this.qmsservice.activity.auId + ']';
    this.dynamicAuditTrailComponent.triggerTrail(recommendation);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Recommendation Report [' + this.qmsservice.activity.auId + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';

  }
  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  editorName: string = '';
  editorTitle: string = '';
  visibleEditor: any;

  // ✅ Opens the editor popup
  public openEditor(value: string, icon: string): void {
    // Mapping of editor titles to their corresponding dynamic labels
    const editorTitleMapping: Record<string, any> = {
      'Description': this.dynamicLabel?.['DESCRIPTION'],
      'Reference Details': this.dynamicLabel?.['REFERENCE_DETAILS'],
      'Auditee Comments': this.dynamicLabel?.['AUDITEE_COMMENTS'],
    };

    this.allowEditing = icon === 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];

    // Retrieve existing value from qmsAuRecommendationsFieldData (same logic as before)
    const actualKey = this.fieldNameMap[value];
    this.editorValue = this.qmsAuRecommendationsFieldData[actualKey] || '';

    // Open editor popup
    this.visibleEditor = this.dialog.open(this.editor, {
      ...this.editorConfig,
      disableClose: icon === 'edit' // prevent closing if editing
    });
  }

  // ✅ Save (OK) button handler
  public saveEditor(editorValue: string): void {
    const actualKey = this.fieldNameMap[this.editorName];
    if (actualKey) {
      this.qmsAuRecommendationsFieldData[actualKey] = editorValue;
    }
    this.visibleEditor.close();
  }

  // ✅ Cancel button handler
  public cancelEditor(): void {
    this.visibleEditor.close();
  }

  public focusEmpty() {
    console.log();
  }

}
